import { EventEmitter, Injectable } from '@angular/core';

@Injectable()
export class SubscribeService {
  subscribe(eventName: string, context: object, callback: (a: any) => any) {
    if (!this.hasOwnProperty(eventName)) {
      this[eventName] = new EventEmitter();
    }
    return this[eventName].subscribe((item: any) => callback.call(context, item));
  }

  publish(eventName: string, data?: any) {
    if (!data) { data = {}; }

    if (!this.hasOwnProperty(eventName)) {
      this[eventName] = new EventEmitter();
    }
    this[eventName].emit(data);
  }
}
